// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__rDapz","login":"Auth_login__Ay-10"};